import * as THREE from 'three';
import { Pane } from 'tweakpane';
import * as CamerakitPlugin from '@tweakpane/plugin-camerakit';
import barba from "@barba/core";

import Circles from "./circles";


export function getFovHeigth(camera, distance) {
    const vFOV = camera.fov * Math.PI / 180
    const minY = 2 * Math.tan(vFOV / 2) * distance
    return minY
}

export default class PictureFull {
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera( 60, 1, 0.1, 60 );
    renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
    });
    intersectable = false;
    pointer = new THREE.Vector2();
    raycaster = new THREE.Raycaster();
    INTERSECTED = undefined;
    components = {};
    srcollTriggers = [];
    PARAMS = {
        x: 0,
        y: 0,
        z: 0,
        a: 0
    }
    constructor({ el, container }) {
        this.el = el;
        this.container = container;
        this.$graphics = this.el.querySelector(".scene");
        this.header = document.body.querySelector("header");

        this.renderer.setClearColor( new THREE.Color(0xffffff) );
        this.renderer.setClearAlpha( this.PARAMS.a );

        this.initialize();
        this.setComponents();
        this.setScrollTriggers();
        
        const discover = this.container.querySelector(".wp-block-omnicom-portal:first-child .discover")

        discover.addEventListener("click", () => {
            const trigger = this.srcollTriggers[0];
            const scrollPosition = trigger.start + (trigger.end - trigger.start) * trigger.animation.labels["slide0"] / trigger.animation.duration();

            gsap.to(document.body.querySelector(`[data-barba="container"]`), { duration: 2, scrollTo: scrollPosition, ease: "power2.inOut" });
        })

        this.handleResize();
        this.boundResize = this.handleResize.bind(this);
        ScrollTrigger.addEventListener("refresh", this.boundResize)
        window.addEventListener("resize", this.boundResize);


        this.onMouseMove = this.onMouseMove.bind(this);
        window.addEventListener('mousemove', this.onMouseMove);

        this.onClick = this.onClick.bind(this);
        window.addEventListener('click', this.onClick);
        
        this.renderer.setAnimationLoop(this.hanedleRender.bind(this));
    }

    setComponents() {
        const { scene, el } = this;
        this.components.circles = new Circles({ scene, el })
    }

    setTimelines() {
        const hero = this.container.querySelector(".wp-block-omnicom-portal:first-child")
        // gsap.set(hero, { perspective: 800, transformStyle: "preserve-3d", autoAlpha: 0 });
        gsap.set(hero, { perspective: 800, transformStyle: "preserve-3d", autoAlpha: 1 });

        SplitText.create(hero.querySelector("h2"), { type: "lines", linesClass: "line" });
        
        const child = hero.querySelector(".discover")
        const wrapper = document.createElement('div');
        wrapper.classList.add('intro-helper');   // ← add your class(es) here

        wrapper.appendChild(child);
        
        hero.appendChild(wrapper);
            
        const items = hero.querySelectorAll(`
            .subtitle,
            .line,
            .discover
        `)

        hero.querySelectorAll(`
            .subtitle,
            .line
        `).forEach((child) => {
            const span = document.createElement("span");
            span.classList.add("intro-helper")

            span.innerHTML = child.innerHTML

            child.innerHTML = ""
            child.appendChild(span)
        })


        gsap.set(items, { autoAlpha: 0, y: 150, z: 200, perspective: 800, }, "debut");

        const heroTimeline = new gsap.timeline({ paused: true });
        gsap.fromTo(hero.querySelectorAll(`.intro-helper`), { autoAlpha: 0, y: 150, z: 200 }, { autoAlpha: 1, delay: 0.1, y: 0, z: 0, duration: 2, stagger: 0.05, ease: "expo.out" });
        heroTimeline.add("entered");
        heroTimeline.fromTo(items, {autoAlpha: 1, y: 0, z: 0}, { autoAlpha: 0, y: 0, z: -200, duration: 2, stagger: 0.05, ease: "expo.in" }, "leave");
        heroTimeline.add("left");

        return {
            heroTimeline
        }
    }

    setScrollTriggers() {
        const { PARAMS } = this;
        const { heroTimeline } = this.setTimelines()



        const hero = this.container.querySelector(".wp-block-omnicom-portal:first-child")

        // const introAnimation = new gsap.timeline({
        //     // delay: 0.1
        // })
        //     // .set(hero, { autoAlpha: 1})
        //     .add(
        //         heroTimeline
        //             .tweenFromTo("debut", "entered", {
        //                 onUpdate: () => {
        //                     console.log("DEBUTing")
        //                 },
        //                 duration: 2,
        //                 ease: "linear"
        //             })
        //         , 'a'
        //     )

        const { animation } = this.components.circles
        animation
            .add(
                heroTimeline.tweenFromTo("entered", "left", {
                    duration: 0.75,
                    ease: "linear"
                }),
                'intro'
            )
            .to(PARAMS, {
                a: 1,
                duration: 0.3,
                overwrite: true,
                onStart: () => {
                    this.header.classList.remove("has-contrast-background-color");
                    this.header.classList.remove("has-surface-background-color");
                },
                onReverseComplete: () => {
                    this.header.classList.add("has-contrast-background-color");
                },
                onUpdate: () => {
                    this.renderer.setClearAlpha( PARAMS.a );
                }
            }, 'intro+=0.75')


        const mainScrollTrigger = ScrollTrigger.create({
            trigger: this.el,
            scroller: this.container,
            start: 'top top',
            end: 'bottom bottom',
            scrub: 1,
            invalidateOnRefresh: true,
            immediateRender: false,
            snap: {
                snapTo: 'labels',
                duration: { min: 0.2, max: 0.8 }, 
                inertia: true,
                ease: 'power3.inOut'
            },
            animation,
            // onUpdate: () => {
            //     if (introAnimation.isActive()) {
            //         introAnimation.kill(false);
            //     }
            // },
            onEnter: () => {
                this.intersectable = true;
            },
            onEnterBack: () => {
                this.intersectable = true;
                this.header.classList.remove("has-contrast-background-color");
                this.header.classList.remove("has-surface-background-color");
            },
            onLeave: () => {
                this.intersectable = false;
            },
            onLeaveBack: () => {
                this.intersectable = false;
            },
            // markers: true,
        });
        this.srcollTriggers.push(mainScrollTrigger);


        const endScrollTrigger = ScrollTrigger.create({
            trigger: this.el,
            scroller: this.container,
            start: 'bottom bottom',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true,
            immediateRender: false,
            animation: new gsap.timeline().fromTo(this.$graphics.querySelector("canvas"), {
                yPercent: 0
            }, {
                yPercent: 31.4,
                ease: "linear",
            }),
            // markers: true,
        });
        this.srcollTriggers.push(endScrollTrigger);
    }

    initialize() {
        const { $graphics } = this;
        //  role="img" aria-label="Vignettes of Omnicom"
        this.renderer.domElement.setAttribute("role", "img");
        this.renderer.domElement.setAttribute("aria-label", "Vignettes of Omnicom");
        $graphics.appendChild( this.renderer.domElement );

        this.camera.position.z = 3.14;

    }

    roundToNearestPI(x)  {return Math.round(x / Math.PI) * Math.PI}

    hanedleRender() {        
        this.camera.updateMatrixWorld();
        this.raycaster.setFromCamera( this.pointer, this.camera );

        const intersects = this.raycaster.intersectObjects( this.components.circles.dna.links.children, true );

        if ( intersects.length > 0 && this.intersectable) {
            document.documentElement.style.cursor = 'pointer';
            document.documentElement.classList.add("intersected-active");
            
            let newIntersected = null;
            for (let i = 0; i < intersects.length; i++) {
                if (intersects[i].object.userData.link) {
                    newIntersected = intersects[i].object;
                    break;
                }
            }
            if (this.INTERSECTED !== newIntersected && newIntersected) {
                this.INTERSECTED = newIntersected;
                gsap.to(this.INTERSECTED.parent.children[0].rotation, { 
                    y: this.roundToNearestPI(this.INTERSECTED.parent.children[0].rotation.y) + Math.PI 
                });
            }
        } else {

            this.INTERSECTED = null;
            document.documentElement.style.removeProperty("cursor");
            document.documentElement.classList.remove("intersected-active");

        }

        this.renderer.render( this.scene, this.camera );
    }

    handleResize() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize( window.innerWidth, window.innerHeight );

        if(this.components.circles) {
            const FOV_H = getFovHeigth(this.camera, 3.14);
            const FOV_W = FOV_H * window.innerWidth / window.innerHeight;
            this.components.circles.dna.FRUSTUM_WIDTH = (FOV_H > FOV_W ? FOV_H : FOV_W) * 1.1
        }
    }

    onMouseMove(event) {
        this.pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
    }

    onClick(event) {
        if (this.INTERSECTED) {
            barba.go( this.INTERSECTED.userData.link )
            this.INTERSECTED = null;
            document.documentElement.style.removeProperty("cursor");
            document.documentElement.classList.remove("intersected-active");
        }
    }

    setDebug() {
        this.pane = new Pane();
        this.pane.registerPlugin(CamerakitPlugin);
        Object.keys(this.components).forEach(_ => {
            if ("setDebug" in this.components[_]) this.components[_].setDebug(this.pane);
        });
    }

    dispose() {
        Object.keys(this.components).forEach(_ => {
            this.components[_].dispose();
            delete this.components[_];
        });

        this.srcollTriggers.forEach(st => st.kill(false))

        // this.initTimeline?.kill();
        window.removeEventListener("resize", this.boundResize);
        ScrollTrigger.removeEventListener("refresh", this.boundResize)

        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('click', this.onClick);
        
        this.renderer.dispose();
    }
}
